import IndexModel from "@/service/v1/sigap/IndexModel";
 
class AulaService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Aula' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    public cadastrarAulaControlador ( dados ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url, dados   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public updateCadastroAula( id , dados  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().put( this.url + '/'  + id  + '/Controlador' ,   dados )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
 
    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

    
    public getNatureza( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetNatureza'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public getTipo( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetTipo'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
   
    public homologar( id ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().patch( this.url + '/'  + id  + '/Homologar' ,   {} )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public arquivar( aula   ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().patch( this.url  + '/'  + aula + '/arquivar' , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }

    
    public homologarFilter( disciplinaId: any, dataMin : any ,  dataMax : any , pelotao: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put(  `${this.url}/Homologar?disciplinaId=${disciplinaId}&DataMin=${dataMin}&DataMax=${dataMax}&pelotao=${pelotao}` )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    
    public arquivarFilter( disciplinaId: any, dataMin : any ,  dataMax : any , pelotao: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put(  `${this.url}/Arquivar?disciplinaId=${disciplinaId}&DataMin=${dataMin}&DataMax=${dataMax}&pelotao=${pelotao}` )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    
    public getProximaAula( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id  + '/Proxima'    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    
    public getAulaAnterior( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id  + '/Anterior'    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
 












    public getAulaView( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id  + '/view'  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public adicionarAuxiliar( aula , dados   ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().post( this.url  + '/'  + aula + '/adicionar/auxiliar' , dados  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public excluirAuxiliar( aula , auxiliar   ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().delete( this.url  + '/' + aula + '/delete/auxiliar/' + auxiliar )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    public getAlunoAjax( id , search ) : Promise<any> {  
        if(search){
            return  new Promise((resolve, reject) => {
                this.getAxios().get( this.url + '/' + id + '/alunos/ajax?search=' + search    )
                .then(response => {    
                    resolve( response.data);  
                })
                .catch(error => {  
                    reject(error.response);
                }) 
            }); 
        } 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/ajax' )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    
 
}
  
export default AulaService; 